<template>
	<div class="spinner-container">
		<div class="circle-spinner">
			<div class="sk-circle1 sk-circle"></div>
			<div class="sk-circle2 sk-circle"></div>
			<div class="sk-circle3 sk-circle"></div>
			<div class="sk-circle4 sk-circle"></div>
			<div class="sk-circle5 sk-circle"></div>
			<div class="sk-circle6 sk-circle"></div>
			<div class="sk-circle7 sk-circle"></div>
			<div class="sk-circle8 sk-circle"></div>
			<div class="sk-circle9 sk-circle"></div>
			<div class="sk-circle10 sk-circle"></div>
			<div class="sk-circle11 sk-circle"></div>
			<div class="sk-circle12 sk-circle"></div>
		</div>
		<span class="spinner-status" v-if="status && status.length">
			{{status}}...
		</span>
	</div>
</template>
<script>
	export default {
		name: 'loading-spinner',
		props: ['status']
	}
</script>
<style lang="scss">
	@import "@/styles/tutorial_editor/globals";

	.spinner-container {
		display: flex;
		flex-direction: row;
		@include breakpoint--desktop-only {
			min-width: 150px;
		}
	}
	.circle-spinner {
		flex: 1 1 20px;
		width: 20px;
		max-width:20px;
		min-width:20px;
		height: 20px;
		transition: all 0.3s $transition-curve;
	}
	.spinner-status {
		flex: 1 1 auto;
		padding-left: 4px;
		font-size: 0.875rem;
		@include breakpoint--mobile-only {
			display: none;
		}
	}
</style>
